var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Box, Button, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { PageLimit, theme } from "@sequentech/ui-essentials";
import { stringToHtml, translate, translateFromPresentation } from "@sequentech/ui-core";
import { styled } from "@mui/material/styles";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { SupportMaterial } from "../components/SupportMaterial/SupportMaterial";
import { getSupportMaterialsList, } from "../store/supportMaterials/supportMaterialsSlice";
import { selectElectionEventById } from "../store/electionEvents/electionEventsSlice";
import Stepper from "../components/Stepper";
import { SettingsContext } from "../providers/SettingsContextProvider";
import { useQuery } from "@apollo/client";
import { GET_DOCUMENT } from "../queries/GetDocument";
import { setDocument } from "../store/documents/documentsSlice";
var StyledTitle = styled(Typography)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-top: 25.5px;\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n    font-size: 24px;\n    font-weight: 500;\n    line-height: 27px;\n    margin-top: 20px;\n    margin-bottom: 16px;\n"], ["\n    margin-top: 25.5px;\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n    font-size: 24px;\n    font-weight: 500;\n    line-height: 27px;\n    margin-top: 20px;\n    margin-bottom: 16px;\n"])));
var ElectionContainer = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: 30px;\n    margin-bottom: 30px;\n"], ["\n    display: flex;\n    flex-direction: column;\n    gap: 30px;\n    margin-bottom: 30px;\n"])));
var ElectionWrapper = function (_a) {
    var material = _a.material;
    var tenantId = useParams().tenantId;
    var i18n = useTranslation().i18n;
    return (_jsx(SupportMaterial, { title: translate(material.data, "title", i18n.language) || "", subtitle: translate(material.data, "subtitle", i18n.language) || "", kind: material.kind || "", tenantId: tenantId || "", documentId: material.document_id || "" }));
};
var SupportMaterialsScreen = function () {
    var _a, _b, _c;
    var _d = useTranslation(), t = _d.t, i18n = _d.i18n;
    var navigate = useNavigate();
    var location = useLocation();
    var _e = useParams(), eventId = _e.eventId, tenantId = _e.tenantId;
    var materials = useAppSelector(getSupportMaterialsList());
    var electionEvent = useAppSelector(selectElectionEventById(eventId));
    var globalSettings = useContext(SettingsContext).globalSettings;
    var dispatch = useAppDispatch();
    var _f = useState([]), materialsList = _f[0], setMaterialsList = _f[1];
    var documents = useQuery(GET_DOCUMENT, {
        variables: {
            ids: (_a = materialsList === null || materialsList === void 0 ? void 0 : materialsList.map(function (material) { var _a; return (_a = material.document_id) !== null && _a !== void 0 ? _a : ""; })) !== null && _a !== void 0 ? _a : [],
            electionEventId: eventId,
            tenantId: tenantId || "",
        },
        skip: globalSettings.DISABLE_AUTH,
    }).data;
    useEffect(function () {
        if (globalSettings.DISABLE_AUTH || !(documents === null || documents === void 0 ? void 0 : documents.sequent_backend_document)) {
            return;
        }
        for (var _i = 0, _a = documents.sequent_backend_document; _i < _a.length; _i++) {
            var document_1 = _a[_i];
            dispatch(setDocument(document_1));
        }
    }, [documents === null || documents === void 0 ? void 0 : documents.sequent_backend_document, globalSettings.DISABLE_AUTH]);
    useEffect(function () {
        var materialsList = [];
        for (var material in materials) {
            materialsList.push(materials[material]);
        }
        setMaterialsList(materialsList);
    }, [materials]);
    var _g = useState(), materialsTitles = _g[0], setMaterialsTitles = _g[1];
    useEffect(function () {
        if (electionEvent) {
            setMaterialsTitles(electionEvent);
        }
    }, [electionEvent]);
    var handleNavigateMaterials = function () {
        navigate("/tenant/".concat(tenantId, "/event/").concat(eventId, "/election-chooser").concat(location.search));
    };
    return (_jsxs(PageLimit, __assign({ maxWidth: "lg" }, { children: [_jsx(Box, __assign({ marginTop: "48px" }, { children: _jsx(Stepper, { selected: 0 }) })), _jsxs(Box, __assign({ sx: {
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    minHeight: "100px",
                } }, { children: [_jsxs(Box, { children: [_jsx(StyledTitle, __assign({ variant: "h1" }, { children: _jsx(Box, { children: materialsTitles &&
                                        ((_b = translateFromPresentation(materialsTitles, "materialsTitle", i18n.language)) !== null && _b !== void 0 ? _b : "-") }) })), _jsx(Typography, __assign({ variant: "body1", sx: { color: theme.palette.customGrey.contrastText } }, { children: stringToHtml(materialsTitles
                                    ? (_c = translateFromPresentation(materialsTitles, "materialsSubtitle", i18n.language)) !== null && _c !== void 0 ? _c : "-"
                                    : "") }))] }), _jsx(Button, __assign({ startIcon: _jsx(ChevronLeftIcon, {}), onClick: handleNavigateMaterials }, { children: t("materials.common.back") }))] })), _jsx(ElectionContainer, { children: materialsList === null || materialsList === void 0 ? void 0 : materialsList.map(function (material) { return (_jsx(ElectionWrapper, { material: material }, material.id)); }) })] })));
};
export default SupportMaterialsScreen;
var templateObject_1, templateObject_2;
